export const ONBOARDING_TRANSLATION_NAMESPACE = "onboarding";

export const ONBOARDING_BILLING_STEP_TK = "ONBOARDING_BILLING_STEP_TK";
export const ONBOARDING_ORGANIZATION_STEP_TK = "ONBOARDING_ORGANIZATION_STEP_TK";
export const ONBOARDING_PASSWORD_STEP_TK = "ONBOARDING_PASSWORD_STEP_TK";
export const ONBOARDING_POS_STEP_TK = "ONBOARDING_POS_STEP_TK";
export const ONBOARDING_SUCCESS_STEP_TK = "ONBOARDING_SUCCESS_STEP_TK";
export const ONBOARDING_COMMON_TK = "ONBOARDING_COMMON_TK";
